import type {ReactElement} from 'react';
import type {AiChatCapability, AiChatCapabilityGroup} from '@AiChat/ai-chat.types';
import type {AiChatQuickTipsCapabilitiesProps} from './ai-chat-quick-tips-capabilities.types';
import styles from './ai-chat-quick-tips-capabilities.module.scss';
import {Text, TextSize, TextTag} from '@Components/text';
import {StaticDot} from '@Components/static-dot/static-dot';
import {StaticDotSize, StaticDotTheme} from '@Components/static-dot/static-dot.types';
import {AiChatQuickTipsCollapsibleCard} from '@AiChat/components/ai-chat-quick-tips/components/ai-chat-quick-tips-collapsible-card/ai-chat-quick-tips-collapsible-card';

export function AiChatQuickTipsCapabilities({headingKey, capabilityGroups, isSmall}: AiChatQuickTipsCapabilitiesProps): ReactElement {
  const renderCapability = (capability: AiChatCapability): ReactElement => (
    <li key={capability.nameKey} className={styles.capability}>
      <StaticDot size={StaticDotSize.SIZE_4} theme={StaticDotTheme.PURPLE} />
      <div className={styles.capabilityText}>
        <Text size={TextSize.MD} bold val={window.i18next.t(capability.nameKey)} />
        <Text size={TextSize.MD} val={window.i18next.t(capability.descriptionKey)} />
      </div>
    </li>
  );

  const renderCapabilityGroup = (capabilityGroup: AiChatCapabilityGroup): ReactElement => (
    <AiChatQuickTipsCollapsibleCard key={capabilityGroup.headingKey} icon={capabilityGroup.icon} title={window.i18next.t(capabilityGroup.headingKey)} titleTag={TextTag.H4}>
      <ul className={`flex-v-row ${isSmall ? 'gap-2' : 'gap-3'} ${styles.capabilityList}`}>{capabilityGroup.capabilities.map(renderCapability)}</ul>
    </AiChatQuickTipsCollapsibleCard>
  );

  return (
    <section className={'flex-v-row gap-3'}>
      <Text tag={TextTag.H3} size={TextSize.MEDIUM} bold className={styles.heading} val={window.i18next.t(headingKey)} />
      <div className={styles.capabilityGroups}>{capabilityGroups.map(renderCapabilityGroup)}</div>
    </section>
  );
}
